import {
  CandidateProfile,
  CvGenerationRequest,
  CvGenerationResponse,
  CvProject,
  FocusArea,
  Industry,
  getDefaultIndustry,
  isKnownIndustry,
} from '../../services/cvGenerator';
import {
  CandidateProfileDto,
  CvProjectDto,
  FocusAreasResponseDto,
  GenerateCvRequestDto,
  GenerateCvResponseDto,
} from './cvApiDtos';

const toIndustry = (value: string): Industry => {
  return isKnownIndustry(value)
    ? value
    : getDefaultIndustry();
};

export const mapCandidateProfileDtoToDomain = (
  dto: CandidateProfileDto
): CandidateProfile => ({
  fullName: dto.fullName,
  title: dto.title,
  description: dto.description || '',
  certifications: [...dto.certifications],
});

export const mapCvProjectDtoToDomain = (dto: CvProjectDto): CvProject => ({
  title: dto.title,
  industry: toIndustry(dto.industry),
  startedAt: dto.startedAt,
  completedAt: dto.completedAt,
  impact: dto.impact,
  technologies: [...dto.technologies],
  focusAreas: [...dto.focusAreas],
});

export const mapGenerateCvRequestToDto = (
  request: CvGenerationRequest
): GenerateCvRequestDto => ({
  targetRole: request.targetRole,
  industries: [...request.industries],
  focusAreas: [...request.focusAreas],
  technologies: [...request.technologies],
  includeCertifications: request.includeCertifications,
  startDate: request.startDate,
});

export const mapGenerateCvRequestDtoToDomain = (
  dto: GenerateCvRequestDto
): CvGenerationRequest => ({
  targetRole: dto.targetRole,
  industries: dto.industries.map(toIndustry),
  focusAreas: [...dto.focusAreas],
  technologies: [...dto.technologies],
  includeCertifications: dto.includeCertifications,
  startDate: dto.startDate,
});

export const mapGenerateCvResponseDtoToDomain = (
  dto: GenerateCvResponseDto
): CvGenerationResponse => ({
  profile: mapCandidateProfileDtoToDomain(dto.profile),
  generatedAt: dto.generatedAt,
  headline: dto.headline,
  summary: dto.summary,
  skills: [...dto.skills],
  certifications: [...dto.certifications],
  projects: dto.projects.map(mapCvProjectDtoToDomain),
  markdown: dto.markdown,
  request: mapGenerateCvRequestDtoToDomain(dto.request),
});

export const mapFocusAreasResponseDtoToDomain = (
  dto: FocusAreasResponseDto
): FocusArea[] => {
  if (Array.isArray(dto)) {
    return [...dto];
  }

  return [...dto.focusAreas];
};
